import { FC } from 'react';
import { ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types/FieldProps';

import { CheckboxListViewModel } from '../../types/checkboxList';
import CheckboxList from '../FieldTemplates/CheckboxList';

const TspCheckboxList: FC<ListFieldProps<CheckboxListViewModel>> = (props) => (
  <div className="tsp-group tsp-consent">
    <CheckboxList {...props} />
  </div>
);

export default TspCheckboxList;
